import { render, staticRenderFns } from "./Sprint.vue?vue&type=template&id=2f35d86a&scoped=true&"
import script from "./Sprint.vue?vue&type=script&lang=js&"
export * from "./Sprint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f35d86a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f35d86a')) {
      api.createRecord('2f35d86a', component.options)
    } else {
      api.reload('2f35d86a', component.options)
    }
    module.hot.accept("./Sprint.vue?vue&type=template&id=2f35d86a&scoped=true&", function () {
      api.rerender('2f35d86a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/SprintPlanning/Components/Sprint.vue"
export default component.exports